import React from "react";
import Container from "../ui/Container";
import Button from "../ui/Button";
import Chip from "../ui/Chip";
import { BRAND, PRICING } from "../../lib/config";
import { Rocket, ChevronDown, Sparkles } from "lucide-react";

export default function Hero() {
  return (
    <section className="relative overflow-hidden bg-[#070A0F]">
      <div aria-hidden className="absolute inset-0">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,rgba(34,211,238,0.18),transparent_55%)]" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_65%,rgba(255,255,255,0.08),transparent_60%)]" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_85%_15%,rgba(217,70,239,0.07),transparent_45%)]" />
        <div className="absolute inset-y-0 left-0 w-40 bg-gradient-to-r from-[#070A0F] to-transparent opacity-80" />
        <div className="absolute inset-y-0 right-0 w-40 bg-gradient-to-l from-[#070A0F] to-transparent opacity-80" />
      </div>

      <Container className="relative z-10">
        <div className="grid min-h-[calc(100vh-4rem)] items-center py-12">
          <div className="mx-auto w-full max-w-4xl text-center">

            {/* Kicker chips */}
            <div className="mb-7 flex flex-wrap items-center justify-center gap-2">
              <Chip>Simple pricing</Chip>
              <Chip>Automatic backups included</Chip>
              <Chip>DDoS protected</Chip>
            </div>

            <h1 className="text-balance text-5xl font-semibold leading-[0.95] tracking-tight text-white sm:text-6xl lg:text-7xl">
              Speed without
              <span className="block">
                compromise
                <span className="text-cyan-300">.</span>
              </span>
            </h1>

            <p className="mx-auto mt-6 max-w-2xl text-pretty text-base leading-7 text-white/70 sm:text-lg">
              Ryzen-powered nodes, transparent pricing, NVMe storage, and backups included by
              default — built for communities that care about performance.
            </p>

            <div className="mt-10 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <Button href="#pricing" className="w-full sm:w-auto">
                Deploy a Server
                <Rocket className="h-4 w-4 opacity-80" />
              </Button>
            </div>

            {/* Tiny trust / risk reversal */}
            <div className="mt-4 text-xs text-white/55">
              Cancel anytime • No setup fees • Not right? We’ll refund you
            </div>

            <a
              href="#pricing"
              className="group mx-auto mt-10 inline-flex items-center gap-2 text-xs text-white/60 hover:text-white/80"
              aria-label="Scroll to pricing"
            >
              Scroll
              <span className="grid h-9 w-9 place-items-center rounded-full border border-white/10 bg-white/[0.04] transition group-hover:bg-white/[0.07]">
                <ChevronDown className="h-4 w-4 opacity-80 transition-transform duration-300 group-hover:translate-y-0.5" />
              </span>
            </a>
          </div>
        </div>
      </Container>
    </section>
  );
}
